<template>

    <DropDown>
        <template v-slot:dropdownLabel>
            <div class="pdf_dropdown_label">
                <IconCloud/> <span> {{ $t('modules.evaluations.index.evalsList.downloadReportTitle') }}</span>
            </div>
        </template>
        <template v-slot:dropdownItems>

             <a v-if="expert_report_url" class="dropdown-item" target="_blank" :href="expert_report_url">{{ $t('modules.evaluations.index.evalsList.recruiterReport') }}</a>
             <!--<span v-else class="dropdown-item disabled_report_link" >{{ $t('modules.evaluations.index.evalsList.recruiterReport') }}</span> -->

             <a v-if="customer_report_url" class="dropdown-item" target="_blank" :href="customer_report_url">{{ $t('modules.evaluations.index.evalsList.customerReport') }}</a>
             <!--<span v-else class="dropdown-item disabled_report_link" >{{ $t('modules.evaluations.index.evalsList.customerReport') }}</span> -->

             <a v-if="passeport_report_url" class="dropdown-item" target="_blank" :href="passeport_report_url">{{ $t('modules.evaluations.index.evalsList.passeportVIP') }}</a>
             <!--<span v-else class="dropdown-item disabled_report_link" >{{ $t('modules.evaluations.index.evalsList.passeportVIP') }}</span> -->

            
        </template>
    </DropDown>

</template>

<script>
export default {
    name: 'ReportsDropDown',
    props: {
        expert_report_url: {
            default: '#!'
        },
        passeport_report_url: {
            default: '#!'
        },
        customer_report_url: {
            default: '#!'
        },
        doc_files: {
            default: function(){
                return []
            }
        }
    }
}


</script>

<style lang="scss" >
.eval_files{
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    overflow: hidden;
    .eval_files_separator{
        border-bottom:  1px solid rgba(10, 10, 10, 0.1);
        margin: 4px 0;
    }
    .eval_file_item{
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        width: 100%;
        .eval_file_item_link{
            color: #4ba6e7;
            padding: 6px 14px;
            white-space: normal!important;
            word-wrap: break-word!important;
            width: calc(100% - 30px);
        }
        .eval_file_item_delete{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            font-size: 1.5rem;
            color: $danger;
            flex:1;
            padding: 6px 0;
            transition: .3s all ease-in-out;
            cursor: pointer;
            &:hover{
                background: $danger;
                color: white;
            }
        }
        &:hover {
            background-color: whitesmoke;
            color: #1f90e0;
        }
    }
}
.pdf_dropdown_label{
    display: flex;
    align-items: center;
    color: $info;
    svg{
        margin-top: 5px;
        width: 24px;
        fill: $info;
        margin-right: 8px;
    }
}
.disabled_report_link{
    font-style: italic;
    background: $white-ter;
    color: $grey-light!important;
}
</style>